module.exports = __webpack_public_path__ + "img/2024-09.f3f574de.jpg";